module.exports = __webpack_public_path__ + "img/Feature.9e0fd7e8.png";